import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { formatWithCallback } from './date'
import { endOfYear, startOfYear } from 'date-fns'

interface DateRangeState {
  startDate: string
  endDate: string
  setDateRange: (startDate: string, endDate: string) => void
  resetToDefault: () => void
}

const getDefaultDates = () => ({
  startDate: formatWithCallback(new Date().toString(), 'yyyy-MM-dd', -7) || '',
  endDate: formatWithCallback(new Date().toString(), 'yyyy-MM-dd', 0) || '',
})

export const useDateRangeStore = create<DateRangeState>()(
  persist(
    (set) => ({
      ...getDefaultDates(),
      setDateRange: (startDate: string, endDate: string) => set({ startDate, endDate }),
      resetToDefault: () => set({
        startDate: formatWithCallback(startOfYear(new Date()).toDateString()),
        endDate: formatWithCallback(endOfYear(new Date()).toDateString()),
      }),
    }),
    {
      name: 'date-range-storage',
      onRehydrateStorage: () => {
        // Optional: handle rehydration
        return (state) => {
          if (!state) {
            // If no state is found in storage, set default dates
            useDateRangeStore.setState(getDefaultDates())
          }
        }
      },
    }
  )
)

// Helper to safely get dates even if store is not initialized
export const getDateRange = () => {
  const state = useDateRangeStore.getState()
  return state || getDefaultDates()
} 